import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { routes } from './routes';
import RoutesWrapper from './utils/RoutesWrapper';
import { LanguageProvider } from './context/LanguageContext';

function App() {
  return (
    <Router>
      <LanguageProvider>
        <RoutesWrapper>
          <Routes>
            {routes.en.concat(routes.es).map((route, index) => (
              <Route key={index} path={route.path} element={route.element} />
            ))}
          </Routes>
        </RoutesWrapper>
      </LanguageProvider>
    </Router>
  );
}

export default App;
